import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-suguyaku-oem-login-message',
  templateUrl: './suguyaku-oem-login-message.component.html',
  styleUrls: [
    '../style/global.css',
    './suguyaku-oem-login-message.component.css',
  ],
})
export class SuguyakuOemLoginMessageComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void { }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }

  get isEaj() {
    return this.oemId === 'EAJ';
  }
}
